import React from 'react';
import { Threshold } from '@modules/iot/model';
import { FieldErrors, FieldValues } from 'react-hook-form/dist/types';
import { FieldPathByValue } from 'react-hook-form/dist/types/path/eager';
import { Control, useController, get } from 'react-hook-form';
import { Measure } from '@modules/measures/model';
import { LastMeasureUtils } from '@modules/measures/last/utils';
import NumericMeasure = LastMeasureUtils.NumericMeasure;
import TemperatureScaleEdit from '@shared/modules/threshold/TemperatureScaleEdit';
import HumidityScaleEdit from '@shared/modules/threshold/HumidityScaleEdit';

interface ThresholdScaleControllerProps<
  TFieldValues extends FieldValues,
  TPath extends FieldPathByValue<TFieldValues, ThresholdType>,
> {
  name: TPath;
  control: Control<TFieldValues>;
  type: NumericMeasure;
}

type ThresholdType = Threshold.Scale<Measure.Value<NumericMeasure>, Threshold.Level>;

function ThresholdScaleController<
  TFieldValues extends FieldValues,
  TPath extends FieldPathByValue<TFieldValues, ThresholdType>,
>({ type, name, control }: ThresholdScaleControllerProps<TFieldValues, TPath>) {
  const { field, formState } = useController({
    name,
    control,
  });

  const errors: FieldErrors<ThresholdType> = get(formState.errors, name);

  //todo: transmit ref for focusing errors

  switch (type) {
    case Measure.Type.Humidity:
      return <HumidityScaleEdit onChange={field.onChange} values={field.value} errors={errors} />;
    case Measure.Type.Temperature:
      return <TemperatureScaleEdit onChange={field.onChange} values={field.value} errors={errors} />;
    default:
      return null;
  }
}

export default ThresholdScaleController;
